import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Intro",
    component: () => import("@/views/Intro.vue"),
    meta: {
      bottomLayout: "none",
      headerLayout: "none",
    },
  },
  {
    path: "/home",
    name: "Home",
    component: () => import("@/views/Home.vue"),
  },
  {
    path: "/marketplace",
    name: "Marketplace",
    component: () => import("@/views/Marketplace.vue"),
    meta: {
      bottomLayout: "marketplace",
      headerLayout: "shrink",
    },
  },
  {
    path: "/prodotto",
    name: "Prodotto",
    component: () => import("@/views/Prodotto.vue"),
    meta: {
      bottomLayout: "marketplace",
      headerLayout: "none",
    },
  },
  {
    path: "/segnala",
    name: "Segnala",
    component: () => import("@/views/Segnala.vue"),
    meta: {
      bottomLayout: "segnala",
      headerLayout: "none",
    },
  },
  {
    path: "/profilo",
    name: "Profilo",
    component: () => import("@/views/Profile.vue"),
    meta: {
      bottomLayout: "none",
      headerLayout: "shrink",
    },
  },
  {
    path: "/punti",
    name: "Punti",
    component: () => import("@/views/Punti.vue"),
    meta: {
      bottomLayout: "none",
      headerLayout: "shrink",
    },
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
];

const router = new VueRouter({
  routes,
});

export default router;
